import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "context";
import { QueryKeys } from "queryClient";
import { getExpansionListForBuyingProducts } from "modules/expansions/api";
import { useExpansionListFilterAndSort } from "../useExpansionListFilterAndSort";

export const useExpansionListForBuyingProducts = (filter = true) => {
  const filterAndSortExpansions = useExpansionListFilterAndSort(filter);

  const { isAuth, isLoading: isLoadingAuth } = useAuthContext();

  const { data, isLoading } = useQuery({
    queryKey: [QueryKeys.Expansions, { outOfStockSelection: "Include" }],
    queryFn: async () => {
      const expansionList = await getExpansionListForBuyingProducts(isAuth);

      return expansionList;
    },
    staleTime: 1000 * 60 * 15, // 15 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    enabled: !isLoadingAuth,
  });

  const expansionList = useMemo(
    () => filterAndSortExpansions(data ?? []),
    [data, filterAndSortExpansions],
  );

  return {
    expansionList,
    isLoading,
  };
};
